import { ICONS } from '../../../icons';

export const CUSTOM_SIZE_ID = 'custom-size';

export const RATIO_LABEL_KEYS = {
  original: 'formatOriginal',
  '1:1': 'format11',
  '16:9': 'format169',
  '9:16': 'format916',
  '4:5': 'format45',
  '3:4': 'format34',
};

export const GROUP_ICONS = {
  instagram: ICONS.InstagramLogo,
  facebook: ICONS.FacebookLogo,
  x: ICONS.TwitterLogo,
  linkedin: ICONS.LinkedInLogo,
  youtube: ICONS.YouTubeShortLogo,
};
